import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

const useCasinoMenuList = () => {
  const { casinoCategory: categorySlug } = useParams()
  const { showBanner } = useSelector(state => state?.loader)
  const showAboutUsInLobby = useSelector(state => state?.uiConfig?.general?.showAboutUsInLobby)
  const casinoCategoryRows = useSelector(state => state?.casinoMenu?.gameCategory?.casinoCategories?.rows)
  // Banners are assigned by tenant category id, so resolve it from the route slug (AMGP-3866)
  const categoryId = casinoCategoryRows?.find(category => category?.slug === categorySlug)?.id

  return {
    showAboutUsInLobby,
    showBanner,
    categorySlug,
    categoryId
  }
}

export default useCasinoMenuList
